import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule, CurrencyPipe, NgFor } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { GalleryModule } from 'ng-gallery';
import { LightboxModule } from 'ng-gallery/lightbox';

import { SwiperModule } from 'swiper/angular';
import { GoogleMapsModule } from '@angular/google-maps';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { Chart, BarElement, Legend, PieController, BarController, ArcElement, Tooltip, CategoryScale, LinearScale, LineController, PointElement, LineElement } from 'chart.js';
Chart.register(PieController, BarElement, Legend, BarController, LineController, CategoryScale, LinearScale, ArcElement, Tooltip, PointElement, LineElement);

import { ProjectsRoutingModule } from './projects-routing.module';

import { ProjectPurchaseComponent } from './project-purchase/project-purchase.component';
import { ProjectMarketComponent } from './project-market/project-market.component';
import { ProjectInfoComponent } from './project-info/project-info.component';
import { ProjectInfoCardComponent } from './project-info/project-info-card/project-info-card.component';
import { ProjectInfoDeveloperComponent } from './project-info/project-info-developer/project-info-developer.component';
import { ProjectInfoLocationComponent } from './project-info/project-info-location/project-info-location.component';
import { ProjectInfoNavComponent } from './project-info/project-info-nav/project-info-nav.component';
import { ProjectInfoDetailComponent } from './project-info/project-info-detail/project-info-detail.component';
import { ProjectInfoOperationComponent } from './project-info/project-info-operation/project-info-operation.component';
import { PipesModule } from '@app/pipes';
import { ProjectInfoProjectionComponent } from './project-info/project-info-projection/project-info-projection.component';
import { ProjectInfoUpdatesComponent } from './project-info/project-info-updates/project-info-updates.component';
import { CardsProjectV2Component } from "../../shared/cards-project-v2/cards-project-v2.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatTabsModule,
    MatTooltipModule,
    MatButtonModule,
    MatSelectModule,
    FontAwesomeModule,
    GoogleMapsModule,
    SwiperModule,
    GalleryModule,
    LightboxModule,
    AsyncPipe,
    NgFor,
    PipesModule,
    ReactiveFormsModule,
    ProjectsRoutingModule,
    CardsProjectV2Component
],
  declarations: [
    ProjectPurchaseComponent,
    ProjectMarketComponent,
    ProjectInfoComponent,
    ProjectInfoCardComponent,
    ProjectInfoDeveloperComponent,
    ProjectInfoLocationComponent,
    ProjectInfoNavComponent,
    ProjectInfoDetailComponent,
    ProjectInfoOperationComponent,
    ProjectInfoProjectionComponent,
    ProjectInfoUpdatesComponent,
  ],
  providers: [
    CurrencyPipe
  ]
})
export class ProjectsModule { }
